import React, { useLayoutEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import LogoDark from '../../assets/imgs/logo2.png'
import LogoLight from '../../assets/imgs/logo_light.svg'
import "./auth.css"
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";


const VerifyOTP = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const { mobile, fromForgotPassword } = location?.state || {};

    const validationSchema = Yup.object().shape({
        otp: Yup.number().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            otp: "",
        },

        onSubmit: async (data) => {
            console.log(data)
            setSaveBtnLoading(true);

            try {
                const payload = {
                    mobile: mobile,
                    mobileOTP: data?.otp
                }
                const response = await dispatch(handlePostRequest('api/user/verifymobile', payload, true, true));
                console.log('response', response)
                if (response?.status == 202) {

                    history.push({
                        pathname: "./reset-password",
                        state: {
                            mobile: mobile,
                            fromVerifyOtp: true
                        }
                    })
                }
                setSaveBtnLoading(false);
            }
            catch (error) {
                console.log(error)
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    useLayoutEffect(() => {
        if (!fromForgotPassword) {
            history.push("./forgot-password")
        }
    }, [fromForgotPassword])

    return (

        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="flex login-main-body align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
                    <div className="login-div-border">
                        <div className="w-full surface-card py-8 px-5 sm:px-6">
                            <div className="text-center mb-5">
                                <img src={true ? LogoLight : LogoDark} alt="Image" height="80" className="w-18rem mb-5" />
                                <div className="text-3xl font-medium mb-3" style={{ color: 'whitesmoke' }}>OTP Verification</div>
                                <span className="font-medium">We have send otp to your mobile number</span>
                            </div>

                            <div className="login-div">
                                <div className="flex justify-content-center mb-5">
                                    <InputText name="otp" id="otp" className="otp-button" type="number" value={formik?.values?.otp} onChange={formik.handleChange}
                                    />
                                </div>
                                <Button label="Next" loading={saveBtnLoading} type="submit" className="w-full mt-3 mb-3 p-3 text-xl" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>

    );
};

export default VerifyOTP;
